import { meanBy, orderBy } from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import {
	getClimateData,
	getDashboardConfiguration,
	getDashboardData,
	getDashboardPicked,
	saveDashboardConfiguration,
} from '../../services/requests/DashboardAnaliseDetalhada'

Vue.use(Vuex)

const initState = () => {
	return {
		dataEscolhida: '',
		dashboardData: { fazendas: [], amostras: [] },
		customizada: '',
		climate: [],
		datasMedicao: [],
		dataUltimoProcessamento: undefined,
	}
}

const state = initState()

const actions = {
	getDashboardData: ({ state }) => {
		return state.dashboardData
	},

	resetCurrentState({ commit }) {
		commit('resetState')
	},
}

const mutations = {
	resetState(state) {
		Object.assign(state, initState())
	},
	setDashboardData: (state) => {
		getDashboardConfiguration().then((response) => {
			console.log(response)
			if (response.data.result) {
				state.customizada = response.data.result.customizada
			}
		})

		getDashboardData().then((response) => {
			// response.data.result.fazendas = response.data.result.fazendas.slice(0, 5)
			response.data.result.fazendas.forEach((fazenda) => {
				fazenda.dadosNivelPlantio.forEach((plantio) => {
					plantio.medicoes.forEach((f) => {
						f.dataMedicao = new Date(f.dataMedicao).toISOString()
					})

					plantio.volumeMedio = meanBy(plantio.medicoes, (o) => o.volumeComCasca)
					plantio.dapMedio = meanBy(plantio.medicoes, (o) => o.dap)
					plantio.htMedio = meanBy(plantio.medicoes, (o) => o.ht)
					plantio.variavelCustomizada.push({ name: 'Plantio', value: plantio.codigo })
					plantio.customizada =
						plantio.variavelCustomizada.find((f) => f.name === state.customizada)?.value ||
						plantio.codigo
				})
			})

			state.dashboardData = response.data.result

			const datas = [
				...new Set(
					response.data.result.fazendas
						.map((fazendas) => {
							return fazendas.dadosNivelPlantio.map((plantio) => plantio.medicoes).flat()
						})
						.flat()
						.map((m) => m.dataMedicao),
				),
			]

			state.datasMedicao = orderBy(datas, [], ['desc'])
			state.dataEscolhida = state.datasMedicao[0]

			state.dataUltimoProcessamento = state.datasMedicao[0]

			// const max = Math.max(...datas.map(m => new Date(m).getTime()))
			// const min = Math.min(...datas.map(m => new Date(m).getTime()))

			// getClimateData({
			//   farmId: state.dashboardData.fazendas[0].id,
			//   startTimestamp: min,
			//   endTimestamp: max,
			// }).then((resp) => {
			//   resp.data.result.forEach((r) => (r.timestamp = new Date(r.date).getTime()));
			//   state.climate = orderBy(resp.data.result, (o) => o.timestamp, ["desc"]);
			// });
		})
	},

	setClimateForFarm: (state, farmId) => {
		// usa o mesmo intervalo de datas que você já calcula no setDashboardData
		const datas = state.datasMedicao.map((d) => new Date(d).getTime())
		const max = Math.max(...datas)
		const min = Math.min(...datas)

		getClimateData({
			farmId,
			startTimestamp: min,
			endTimestamp: max,
		}).then((resp) => {
			resp.data.result.forEach((r) => (r.timestamp = new Date(r.date).getTime()))
			state.climate = orderBy(resp.data.result, (o) => o.timestamp, ['desc'])
		})
	},
	// Limpa os dados climáticos
	clearClimate: (state) => {
		state.climate = []
	},

	setDashboardDatePicker: (state, data) => {
		getDashboardPicked(data).then((response) => {
			console.log(response)
			if (response.data.result) {
				response.data.result.fazendas.forEach((fazenda) => {
					fazenda.dadosNivelPlantio.forEach((plantio) => {
						plantio.medicoes.forEach((f) => {
							f.dataMedicao = new Date(f.dataMedicao).toISOString()
						})

						plantio.volumeMedio = meanBy(plantio.medicoes, (o) => o.volumeComCasca)
						plantio.dapMedio = meanBy(plantio.medicoes, (o) => o.dap)
						plantio.htMedio = meanBy(plantio.medicoes, (o) => o.ht)
						plantio.variavelCustomizada.push({ name: 'Plantio', value: plantio.codigo })
						plantio.customizada =
							plantio.variavelCustomizada.find((f) => f.name === state.customizada)?.value ||
							plantio.codigo
					})
				})

				state.dashboardData = response.data.result

				const datas = [
					...new Set(
						response.data.result.fazendas
							.map((fazendas) => {
								return fazendas.dadosNivelPlantio.map((plantio) => plantio.medicoes).flat()
							})
							.flat()
							.map((m) => m.dataMedicao),
					),
				]
				state.datasMedicao = orderBy(datas, [], ['desc'])
				state.dataEscolhida = state.datasMedicao[0]

				const max = Math.max(...datas.map((m) => new Date(m).getTime()))
				const min = Math.min(...datas.map((m) => new Date(m).getTime()))

				getClimateData({
					farmId: state.dashboardData.fazendas[0].id,
					startTimestamp: min,
					endTimestamp: max,
				}).then((resp) => {
					resp.data.result.forEach((r) => (r.timestamp = new Date(r.date).getTime()))
					state.climate = orderBy(resp.data.result, (o) => o.timestamp, ['desc'])
				})
			}
		})
	},

	setCustomizada: (state, data) => {
		state.customizada = data

		state.dashboardData.fazendas.forEach((fazenda) => {
			fazenda.dadosNivelPlantio.forEach((plantio) => {
				plantio.customizada =
					plantio.variavelCustomizada.find((f) => f.name === state.customizada)?.value ||
					plantio.codigo
			})
		})

		saveDashboardConfiguration({ customizada: data }).then((response) => {
			console.log(response)
		})
	},
}

const getters = {
	isEmpty: (state) => {
		return !Object.values(state.dashboardData).every((e) => e.length)
	},
	getMedicoes: (state) => {
		const data = new Date(
			new Date(state.dataEscolhida || state.datasMedicao[0]).setHours(0, 0, 0, 0),
		).toISOString()
		return state.dashboardData.fazendas
			.flatMap((fazenda) => fazenda.dadosNivelPlantio)
			.flatMap((plantio) => plantio.medicoes)
			.filter((medicao) => medicao.dataMedicao === data)
	},
}
const store = new Vuex.Store({ state, actions, mutations, getters })

export const useStore = () => store
